import pfSelect from './pfSelect'
// import pfTreeSelect from './pfTreeSelect'
// import pfDistrict from './pfDistrict'
// import pfDic from './pfDic'
// import pfDicData from './pfDicData'
// import pfTree from './pfTree'
import pfFileUpload from './pfFileUpload'
// import pfUser from './pfUser'
// import pfDepartment from './pfDepartment'
// import pfMultipleDepartment from './pfMultipleDepartment'
export default {
  install: Vue => {
    Vue.component('pf-select', pfSelect)
    // Vue.component('pf-tree-select', pfTreeSelect)
    // Vue.component('pf-district', pfDistrict)
    // Vue.component('pf-dic', pfDic)
    // Vue.component('pf-dic-data', pfDicData)
    // Vue.component('pf-tree', pfTree)
    Vue.component('pf-file-upload', pfFileUpload)
    // Vue.component('pf-user', pfUser)
    // Vue.component('pf-department', pfDepartment),
    // Vue.component('pf-multiple-department', pfMultipleDepartment)
  }
}
